export default "__VITE_ASSET__GF6ejeyA__"